/** @jsx jsx */
import React from 'react';
import { jsx } from '@compiled/react';
import transformToISOString from '@atlassian/jira-common-date/src/utils/transform-to-iso-string/index.tsx';
import Timestamp from '@atlassian/jira-issue-timestamp/src/main.tsx';
import { ActivityTimestampStylesControl } from '../styled.tsx';
import { useCommentContext } from './CommentContextProvider.tsx';
import CommentSubtext from './CommentSubtext.tsx';

const CommentTime = () => {
	const { createdDate, eventOccurredAt, isDeleted, isSaving, isError } = useCommentContext();

	if (isDeleted || isSaving || isError) {
		return null;
	}

	const value = eventOccurredAt ? transformToISOString(eventOccurredAt) : createdDate;

	return (
		<CommentSubtext>
			<Timestamp value={value} tooltipPosition="top" extraStyles={ActivityTimestampStylesControl} />
		</CommentSubtext>
	);
};

export default CommentTime;
